import OrganisationIndexGroupMapper from "../service/OrganisationIndexGroupMapper";
import OrganisationIndexGroupParamMapper from "../service/OrganisationIndexGroupParamMapper";
import GetResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { IOrganisationIndexGroup } from "../model/OrganisationIndexGroup";

export default class FindSwitchGroupCandidatesForIndexInteractor {
  private resource: GetResourceEntriesInteractor<IOrganisationIndexGroup>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(indexId: number, organisationId: number) {
    return this.resource.execute(
      `${Constants.organisationsPath}/${organisationId}/groups/indexes`,
      OrganisationIndexGroupMapper,
      OrganisationIndexGroupParamMapper,
      {
        params: { indexId: indexId }
      }
    );
  }
}
